import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ZuordnungWaermeerzeugerHeizungGwrWerte extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    zuordnung_waermeerzeuger_heizung_id: number | null = null;
    waermeerzeuger_heizung_id: number | null = null;
    energie_waermequelle_id: number | null = null;

    // view fields:
    energie_waermequelle_i18n_key: string | null = null;
    waermeerzeuger_heizung_i18n_key: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ZuordnungWaermeerzeugerHeizungGwrWerte';
    }
}

export async function createNewZuordnungWaermeerzeugerHeizungGwrWerte(): Promise<ZuordnungWaermeerzeugerHeizungGwrWerte> {
    const model = createModel(ZuordnungWaermeerzeugerHeizungGwrWerte, {});

    await model.save();
    return model;
}

export class ZuordnungWaermeerzeugerHeizungGwrWerteCollection extends BaseCollection<ZuordnungWaermeerzeugerHeizungGwrWerte> {
    protected modelCls = ZuordnungWaermeerzeugerHeizungGwrWerte;

    public getModelClassName(): string {
        return 'ZuordnungWaermeerzeugerHeizungGwrWerte';
    }
}
